// ---------------------------------------------------------
// Datei: address.ts
// Zweck: Bereinigt Adress-Freitextfelder aus HubSpot (z. B. objekt___anschrift), die häufig
//        eingebettetes HTML enthalten (aus Google Sheets eingefügte Rich-Text-Links zu einer
//        Maps-Suche) — und öffnet daraus Apple Maps/Google Maps statt das rohe HubSpot-HTML zu
//        übernehmen. `openAppleMaps`/`openGoogleMaps` werden von mehreren Seiten genutzt
//        (Projektphasen-Kopfzeile, Projektvorbereitung-Briefing), daher hier zentral statt pro
//        Komponente dupliziert.
// ---------------------------------------------------------

export const sanitizeAddress = (value: string | null | undefined): string =>
  String(value || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();

// Versucht zuerst die native App per Custom-URL-Scheme zu öffnen (funktioniert nur auf iOS/
// Android mit installierter App); ist keine App installiert, bleibt der Seitenwechsel aus und
// der Web-Fallback öffnet nach kurzer Verzögerung in einem neuen Tab.
export const openAppleMaps = (address: string): void => {
  const encoded = encodeURIComponent(address);
  const appUrl = `maps://?daddr=${encoded}&dirflg=d`;
  const webUrl = `https://maps.apple.com/?daddr=${encoded}&dirflg=d`;
  window.location.href = appUrl;
  setTimeout(() => window.open(webUrl, '_blank', 'noopener,noreferrer'), 600);
};

export const openGoogleMaps = (address: string): void => {
  const encoded = encodeURIComponent(address);
  const appUrl = `comgooglemaps://?daddr=${encoded}&directionsmode=driving`;
  const webUrl = `https://www.google.com/maps/dir/?api=1&destination=${encoded}&travelmode=driving`;
  window.location.href = appUrl;
  setTimeout(() => window.open(webUrl, '_blank', 'noopener,noreferrer'), 600);
};
